"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationErrorWrapper = void 0;
const actions_core_1 = require("@segment/actions-core");
const operationTracking_1 = require("./operationTracking");
class IntegrationErrorWrapper {
    static getTryCatchFinallyHook(_ctx) {
        return this;
    }
    static onCatch(ctx) {
        const getWrapper = ctx.decoratorArgs?.wrapIntegrationError;
        if (!getWrapper)
            return;
        ctx.error = this.wrap(ctx.error, () => getWrapper(ctx), ctx);
    }
    static wrap(error, getWrapper, ctx) {
        return operationTracking_1.OperationErrorHandler.wrap(error, () => {
            if (error instanceof actions_core_1.IntegrationError)
                return error;
            const wrapper = getWrapper();
            const resultError = (Array.isArray(wrapper) ? new actions_core_1.IntegrationError(...wrapper) : wrapper);
            const responseErrorStatus = resultError.response?.data?.status;
            if (responseErrorStatus) {
                resultError.status = responseErrorStatus;
            }
            return resultError;
        }, ctx);
    }
}
exports.IntegrationErrorWrapper = IntegrationErrorWrapper;
//# sourceMappingURL=IntegrationErrorWrapper.js.map